/**
 * MO Constants - RX values, tags, keys, disclaimers
 * Migrated from src/alpine/utils/constants.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  var KEY = {
    CATEGORY: "category",
    FRAME: "frame",
    EYEWEAR: "eyewear",
    LENS_TYPE: "lens-type",
    LENS_FEATURE: "lens-feature",
    TRANSITIONS_TYPE: "transitions-type"
  };

  var TAG = {
    CATEGORY_NON_PRESCRIPTION: "category_non-prescription",
    CATEGORY_PRESCRIPTION: "category_prescription",
    EYEWEAR_SUNGLASSES: "eyewear_Sunglasses",
    LENS_TYPE_POLICARBONAT: "lens-type_Polycarbonate",
    LENS_TYPE_TRIVEX_CB: "lens-type_Trivex CB",
    LENS_TYPE_TRIVEX: "lens-type_Trivex",
    LENS_FEATURE_POLARIZED: "lens-feature_Polarized"
  };

  var rxValuesByOption = {
    "SPH (Sphere)": {
      defaultValue: "0.00",
      positiveValues: [
        "0.25","0.50","0.75","1.00","1.25","1.50","1.75","2.00",
        "2.25","2.50","2.75","3.00","3.25","3.50","3.75","4.00",
        "4.25","4.50","4.75","5.00","5.25","5.50","5.75","6.00",
        "6.25","6.50","6.75","7.00","7.25","7.50","7.75","8.00"
      ],
      negativeValues: [
        "-0.25","-0.50","-0.75","-1.00","-1.25","-1.50","-1.75","-2.00",
        "-2.25","-2.50","-2.75","-3.00","-3.25","-3.50","-3.75","-4.00",
        "-4.25","-4.50","-4.75","-5.00","-5.25","-5.50","-5.75","-6.00",
        "-6.25","-6.50","-6.75","-7.00","-7.25","-7.50","-7.75","-8.00",
        "-8.25","-8.50","-8.75","-9.00","-9.25","-9.50","-9.75","-10.00"
      ]
    },
    "CYL (Cylinder)": {
      defaultValue: "0.00",
      positiveValues: [
        "0.25","0.50","0.75","1.00","1.25","1.50","1.75","2.00",
        "2.25","2.50","2.75","3.00","3.25","3.50","3.75","4.00",
        "4.25","4.50","4.75","5.00","5.25","5.50","5.75","6.00",
        "6.25","6.50","6.75","7.00","7.25","7.50","7.75","8.00"
      ],
      negativeValues: [
        "-0.25","-0.50","-0.75","-1.00","-1.25","-1.50","-1.75","-2.00",
        "-2.25","-2.50","-2.75","-3.00","-3.25","-3.50","-3.75","-4.00",
        "-4.25","-4.50","-4.75","-5.00","-5.25","-5.50","-5.75","-6.00",
        "-6.25","-6.50","-6.75","-7.00","-7.25","-7.50","-7.75","-8.00",
        "-8.25","-8.50","-8.75","-9.00","-9.25","-9.50","-9.75","-10.00"
      ]
    },
    "Axis": {
      defaultValue: "000",
      positiveValues: [
        "091","092","093","094","095","096","097","098","099","100",
        "101","102","103","104","105","106","107","108","109","110",
        "111","112","113","114","115","116","117","118","119","120",
        "121","122","123","124","125","126","127","128","129","130",
        "131","132","133","134","135","136","137","138","139","140",
        "141","142","143","144","145","146","147","148","149","150",
        "151","152","153","154","155","156","157","158","159","160",
        "161","162","163","164","165","166","167","168","169","170",
        "171","172","173","174","175","176","177","178","179","180"
      ],
      negativeValues: [
        "001","002","003","004","005","006","007","008","009","010",
        "011","012","013","014","015","016","017","018","019","020",
        "021","022","023","024","025","026","027","028","029","030",
        "031","032","033","034","035","036","037","038","039","040",
        "041","042","043","044","045","046","047","048","049","050",
        "051","052","053","054","055","056","057","058","059","060",
        "061","062","063","064","065","066","067","068","069","070",
        "071","072","073","074","075","076","077","078","079","080",
        "081","082","083","084","085","086","087","088","089","090"
      ]
    },
    "Pupil Distance RL": {
      defaultValue: "None",
      positiveValues: [
        "64","65","66","67","68","69","70","71",
        "72","73","74","75","76","77","78","79","80"
      ],
      negativeValues: [
        "46","47","48","49","50","51","52","53",
        "54","55","56","57","58","59","60","61","62","63"
      ]
    },
    "Pupil Distance": {
      defaultValue: "None",
      positiveValues: [
        "32.0","32.5","33.0","33.5","34.0","34.5","35.0","35.5",
        "36.0","36.5","37.0","37.5","38.0","38.5","39.0","39.5","40.0"
      ],
      negativeValues: [
        "23.0","23.5","24.0","24.5","25.0","25.5","26.0","26.5",
        "27.0","27.5","28.0","28.5","29.0","29.5","30.0","30.5","31.0","31.5"
      ]
    },
    "Add": {
      defaultValue: "N/A",
      positiveValues: [
        "+2.25","+2.50","+2.75","+3.00","+3.25","+3.50","+3.75","+4.00"
      ],
      negativeValues: [
        "+0.25","+0.50","+0.75","+1.00","+1.25","+1.50","+1.75","+2.00"
      ]
    },
    "Prism": {
      defaultValue: "0.00",
      positiveValues: [
        "1.05","1.10","1.15","1.20","1.25","1.30","1.35","1.40",
        "1.45","1.50","1.55","1.60","1.65","1.70","1.75","1.80",
        "1.85","1.90","1.95","2.00"
      ],
      negativeValues: [
        "0.05","0.10","0.15","0.20","0.25","0.30","0.35","0.40",
        "0.45","0.50","0.55","0.60","0.65","0.70","0.75","0.80",
        "0.85","0.90","0.95","1.00"
      ]
    }
  };

  var DISCLAIMER_TEXTS = {
    PLANO: {
      Polycarbonate:
        "Polycarbonate lenses are lightweight and highly impact-resistant, making them ideal for everyday use and outdoor activities. They offer excellent clarity, durability, and UV protection, ensuring your eyes are safe and comfortable in various conditions.",
      Polycarbonate_polarized:
        "Polycarbonate Polarized lenses provide superior glare reduction and visual clarity. Perfect for bright environments, these lenses enhance color contrast and reduce eye strain, making them ideal for activities like driving, fishing, and other outdoor adventures.",
      Trivex_polarized:
        "Trivex\u00AE Color-Boosting\u00AE Polarized lenses combine high impact resistance with exceptional optical clarity and lightweight comfort. These lenses reduce glare and boost colors, enhancing visual acuity and depth perception, ideal for dynamic outdoor environments and activities.",
      Golf: "Golf Trivex lenses are specifically designed to enhance performance on the course. Featuring advanced Color-Boosting\u00AE technology, these lenses improve contrast and depth perception, allowing you to better read the greens and track your ball. The lightweight, unbreakable frames ensure comfort throughout your game, helping you focus on your performance."
    },
    Eyeglasses: {
      Polycarbonate:
        "Polycarbonate lenses are lightweight and extremely impact-resistant, making them perfect for everyday wear. These lenses provide excellent optical clarity and 100% UV protection, ensuring your eyes are safe and comfortable in all conditions. Their durability and resilience make them ideal for active lifestyles.",
      Trivex:
        "Trivex\u00AE lenses offer a superior combination of clarity, durability, and lightweight comfort. Known for their exceptional impact resistance, these lenses provide sharper vision and better optical performance than traditional plastic lenses. Trivex lenses are perfect for those who need reliable, high-quality eyewear for daily use, offering enhanced visual acuity and protection."
    },
    RX_Sunglasses: {
      Polycarbonate:
        "Polycarbonate prescription sunglasses offer lightweight comfort and excellent impact resistance, making them ideal for active lifestyles. These lenses provide superior optical clarity and 100% UV protection, ensuring your eyes are well-protected in various environments. ",
      Polycarbonate_polarized:
        "Polycarbonate Polarized prescription sunglasses combine the durability of polycarbonate with advanced polarization technology. These lenses effectively reduce glare, enhance visual clarity, and improve color contrast, making them perfect for outdoor activities in bright conditions.",
      Trivex:
        "Trivex\u00AE Color-Boosting\u00AE prescription sunglasses feature high-impact resistance and superior optical clarity. The color-boosting technology enhances contrast and depth perception, providing vibrant and detailed vision, ideal for dynamic outdoor environments.",
      Trivex_polarized:
        "Trivex Color-Boosting\u00AE Polarized prescription sunglasses offer the ultimate in visual performance. Combining impact-resistant Trivex material with color-boosting and polarized technologies, these lenses reduce glare, enhance colors, and improve overall visual acuity, perfect for any outdoor activity.",
      Golf: "Golf Trivex\u00AE prescription sunglasses are specifically designed to enhance your performance on the course. Featuring advanced Color-Boosting\u00AE technology, these lenses improve contrast and depth perception, allowing you to better read greens and track your ball. The lightweight, unbreakable frames ensure comfort throughout your game, helping you focus on your performance."
    },
    Transitions: {
      Colors:
        "Introducing four vibrant new Transitions\u00AE style colors that allow you to personalize any frame to further express your style. Fully clear indoors and dark outdoors, these are our fastest and most responsive hassle-free lenses for everyday eyecare. With exclusive Chromea7\u2122 photochromic technology, these lenses are ideal for glasses wearers who are both inside and outside during the day.",
      Signature:
        "Best everyday light intelligent lens Transitions\u00AE Signature\u00AE is our fastest and most responsive lens in all lighting and temperature conditions. Extra responsive to darken outdoors in all lighting and temperature conditions. Extra fast fade back from dark outside to clear indoors.",
      XTRActive:
        "Best for extra eyecare protection, even in the car. Uniquely designed to protect your eyes from the brightest sun outdoors and harsh artificial light indoors. Extra dark outdoors to protect your eyes from the brightest sun, even in the hottest conditions. Darkens behind the windshield to protect drivers\u2019 eyes from sunlight.",
      XTRActive_polarized:
        "Best for glare reduction outdoors. The world\u2019s only intelligent lens that automatically polarizes as it darken outdoors. Polarization adjusts to match the level of glare outdoors. Noticeably crisper, sharper vision outdoors.",
      Mirrors:
        "Introducing six intelligent Transitions\u00AE style mirrors that allow you to further freestyle your frames. A hint of tint indoors and the extra protection outdoors\u2014even in the car\u2014help protect from harsh indoor lighting and the brightest sun. Ideal for glasses wearers who are especially sensitive to light."
    }
  };

  var PRESCRIPTION_TYPE = {
    MANUAL: "manual",
    FILE: "file"
  };

  window.MO.constants = {
    KEY: KEY,
    TAG: TAG,
    rxValuesByOption: rxValuesByOption,
    DISCLAIMER_TEXTS: DISCLAIMER_TEXTS,
    PRESCRIPTION_TYPE: PRESCRIPTION_TYPE
  };
})();
